<template>
  <main-template hide-franquia>
    <v-row class="mb-3">
      <v-col cols="12" class="pt-10">
        <h1>Escolas:</h1>
      </v-col>
      <v-col cols="12" v-if="franquiasList.length === 0">
        <v-alert color="warning" icon="fa fa-frown-o"
          >Infelizmente ainda não lhe adicionaram em nenhuma Escola, entre em contato com o setor de
          secretaria/coordenação da sua escola para que criem seus vínculos no diário e suas escolas
          serão listadas aqui.
        </v-alert>
      </v-col>
      <v-col
        v-else
        cols="12"
        md="4"
        v-for="franquia of franquiasList"
        :key="franquia.id"
        align-self="stretch"
      >
        <v-card
          color="indigo darken-4 white--text"
          @click="selecionarFranquiaERedirecionar(franquia)"
          style="height: 100%"
          class="d-flex flex-column justify-space-between"
        >
          <v-card-title>
            <v-icon large left color="white"> mdi-account-multiple </v-icon>
            <span class="title font-weight-light">{{ franquia.descricao }}</span>
          </v-card-title>
          <v-card-text
            v-if="user.roleName === 'professor'"
            class="subtitle font-weight-bold white--text"
          >
            Diários: {{ franquia.qtdGestoesDeAulas }} <br />
            Diários AEE: {{ franquia.qtdGestoesDeAulasAEE }}
          </v-card-text>
          <v-card-text
            v-else-if="user.roleName === 'prof-auxiliar'"
            class="subtitle font-weight-bold white--text"
          >
            Diários: {{ franquia.qtdGestoesDeAulasAuxiliar }}
          </v-card-text>
          <!-- roleName -->
        </v-card>
      </v-col>

      <v-col cols="12">
        <template v-if="avisos.length > 0">
          <div>
            <v-alert color="error" icon="warning" border="left" elevation="2" colored-border>
              <v-row align="center">
                <v-col class="grow"><strong>Avisos</strong> </v-col>
                <v-btn small :to="{ name: 'avisos.index' }" color="secondary">
                  Ver todos por escola
                </v-btn>
              </v-row>
              <div
                v-for="(aviso, index) in avisos.filter((aviso) =>
                  aviso.description_configuracoes.some((desc) => desc.id === user.configuracao_id)
                )"
                :key="index"
                class="mt-1"
              >
                <v-col class="grow">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-row class="px-3" justify="space-between">
                        <span class="d-inline-block title-1 font-weight-bold text-truncate box">
                          {{ aviso.titulo }}
                          -
                          {{
                            aviso.description_configuracoes.find(
                              (desc) => desc.id === user.configuracao_id
                            )?.descricao || aviso.description_configuracoes[0].descricao
                          }}
                        </span>

                        <v-btn icon @click="() => verAviso(aviso.id, aviso)" color="secondary">
                          <span class="material-icons">visibility</span>
                        </v-btn>
                      </v-row>

                      <div>
                        <span
                          class="d-inline-block subtitle-1 font-weight-light box aviso-contexto"
                          v-html="aviso.contexto ? aviso.contexto.replace(/\n/g, '<br>') : ''"
                        ></span>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </v-col>
              </div>
            </v-alert>
          </div>
        </template>
      </v-col>
      <div class="text-center">
        <v-dialog v-model="dialog_aviso" width="374">
          <v-card v-if="!aviso" class="mx-auto" max-width="374">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader class="mx-auto" max-width="374" type="card"></v-skeleton-loader>
            </v-sheet>
          </v-card>

          <v-card v-else class="mx-auto" max-width="374">
            <v-img :src="url_image_aviso" height="200px"></v-img>

            <!-- description_configuracoes -->
            <v-card-subtitle style="text-align: center">
              {{ aviso ? aviso.description_configuracoes[0].descricao : "- - -" }}
            </v-card-subtitle>

            <v-card-title> {{ aviso ? aviso.titulo : "- - -" }} </v-card-title>

            <v-card-subtitle> {{ aviso ? aviso.contexto : "- - -" }} </v-card-subtitle>

            <v-card-actions>
              <v-btn @click="dialog_aviso = false" color="orange lighten-2" text> Fechar </v-btn>

              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-row>

    <v-divider> </v-divider>

    <!-- Gráfico: Quantidade de notas acima e abaixo da média -->
    <v-row class="mt-3 mb-3" v-if="show">
      <v-col cols="6" md="6">
        <v-chip color="indigo" label text-color="white">
          Quantidade de notas acima e abaixo da média
        </v-chip>

        <v-card class="mt-2" min-height="300">
          <template v-if="loadingNotas">
            <v-row justify="center" align="center" style="height: 300px">
              <v-progress-circular indeterminate color="indigo" size="64" width="6" />
              <span class="ml-3">Carregando dados...</span>
            </v-row>
          </template>

          <template v-else>
            <e-dashboard-turma :datasets="datasetsNotas" :labels="labelsNotas" />
          </template>
        </v-card>
      </v-col>

      <!-- Gráfico: Média de notas -->
      <v-col cols="6" md="6">
        <v-chip color="indigo" label text-color="white">Média de notas</v-chip>

        <v-card class="mt-2" min-height="300">
          <template v-if="loadingMedias">
            <v-row justify="center" align="center" style="height: 300px">
              <v-progress-circular indeterminate color="indigo" size="64" width="6" />
              <span class="ml-3">Carregando dados...</span>
            </v-row>
          </template>

          <template v-else>
            <e-dashboard-turma :datasets="datasetsMedias" :labels="labelsMedias" />
          </template>
        </v-card>
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <!-- Gráfico: Quantidade de presenças e faltas por mês -->
    <v-row class="mt-3 mb-3" v-if="show">
      <v-col>
        <v-chip color="indigo" label text-color="white">
          Quantidade de presenças e faltas por mês
        </v-chip>

        <v-card class="mt-2" min-height="300">
          <template v-if="loadingAcompanhamento">
            <v-row justify="center" align="center" style="height: 300px">
              <v-progress-circular indeterminate color="indigo" size="64" width="6" />
              <span class="ml-3">Carregando dados...</span>
            </v-row>
          </template>

          <template v-else>
            <e-dashboard-turma
              :datasets="datasetsAcompanhamentos"
              :labels="labelsAcompanhamentos"
            />
          </template>
        </v-card>
      </v-col>
    </v-row>

    <v-divider> </v-divider>

    <v-row class="mt-3 mb-1" v-if="show">
      <v-col cols="12">
        <v-chip color="indigo" label text-color="white"> Melhores alunos</v-chip>
        <v-card v-for="(item, i) in melhoresAlunos" :key="i" light class="mb-3 mt-1">
          <div class="d-flex flex-no-wrap justify-content">
            <div style="border-right: 1px solid #ccc" class="py-5">
              <div class="d-flex flex-no-wrap justify-content">
                <v-img width="100" :src="coroas[i]"></v-img>
              </div>
              <div style="text-align: center">
                <h3>#{{ ++i }}</h3>
              </div>
            </div>

            <div class="py-5 ml-2">
              <div>
                <h3 class="indigo--text mb-3">
                  {{ item.aluno }}
                </h3>
              </div>
              <v-divider></v-divider>
              <div class="mt-3">
                <span class="">Média: {{ item.media }}</span> <br />
                <span class="">Notas: {{ item.soma_notas }}</span> <br />
                <span class="">Faltas: {{ item.qtdFaltas }}</span>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row class="mt-2" v-if="show">
      <v-col>
        <v-chip color="indigo" label text-color="white"> Alunos </v-chip>
        <v-card class="mt-2">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Procurar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="alunos" :search="search"></v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      show: true,
      turmas: [],
      query: "",
      openSelecionarFranquiaModal: false,
      aulasAguardandoConfirmacaoCount: null,
      carregandoTurmas: false,
      franquiasList: [],
      carregandoFranquias: false,
      labelsNotas: [],
      datasetsNotas: [],
      datasetsMedias: [],
      labelsMedias: [],
      datasetsAcompanhamentos: [],
      labelsAcompanhamentos: [],
      loadingAcompanhamento: false,
      alunos: [],
      melhoresAlunos: [],
      avisos: [],
      aviso: null,
      dialog_aviso: false,
      coroas: [
        "https://img.freepik.com/vetores-gratis/composicao-da-coroa-real-com-imagem-plana-da-coroa-cercada-por-coroas-de-louro-douradas_1284-64252.jpg?w=740&t=st=1661362754~exp=1661363354~hmac=29523ea348e1807edaa9ca4d5abf172c4753f0e7d8a6a968a3c2ff064eaa087a",
        "https://static.vecteezy.com/system/resources/previews/000/554/920/large_2x/royal-crown-vector-icon.jpg",
        "https://static.vecteezy.com/system/resources/previews/000/554/920/large_2x/royal-crown-vector-icon.jpg",
        "https://static.vecteezy.com/system/resources/previews/000/554/920/large_2x/royal-crown-vector-icon.jpg",
      ],
      search: "",
      headers: [
        { text: "Nome", value: "aluno" },
        { text: "Média", value: "media" },
        { text: "Notas", value: "soma_notas" },
        { text: "Faltas", value: "qtdFaltas" },
        { text: "Presenças", value: "qtdPresencas" },
      ],
    };
  },
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  mounted() {
    this.loadData();
    this.avisosProfessor();
    this.$root.$on("franquia-alterada", async () => {
      await this.avisosProfessor();
    });
  },
  beforeDestroy() {
    this.$root.$off("franquia-alterada");
  },
  computed: {
    ...mapGetters("Auth", ["senhaFraca", "user"]),
  },
  methods: {
    async selecionarFranquiaERedirecionar(franquia) {
      this.$loaderService.open("Acessando diários");
      this.ip_do_usuario = await this.$services.webInfo.pegarIpLocalDoUsuario();
      this.dispositivo_do_usuario = this.$services.webInfo.pegarDispositivoDoUsuario();
      try {
        await this.$services.authService.mudarDeFranquia(
          franquia,
          this.ip_do_usuario,
          this.dispositivo_do_usuario
        );
        if (this.user.roleName === "professor") {
          this.$router.push({ name: "gestoesDeAulas" });
        } else {
          this.$router.push({ name: "gestoesDeAulasAEE" });
        }
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async loadData() {
      try {
        this.franquiasList = await this.$services.franquiasService.syncAll();
        await this.getTurmas();

        await this.getNotas();
        await this.getMedias();
        await this.getAlunos();
        await this.getAcompanhamento();

        /* eslint-disable */
        // const hasInfantil = this.franquiasList.some((f) => f.temGestaoInfantil > 0);
        // const hasFundamental = this.franquiasList.some((f) => f.temGestaoEnsinoFundamental > 0);
        // const hasMedio = this.franquiasList.some((f) => f.temGestaoEnsinoMedio > 0);

        // this.show = !hasInfantil || (hasFundamental && hasMedio);

      } catch (error) {
        this.$handleError(error);
      }
      // this.$loaderService.close();
    },

    async getTurmas() {
      const turmas = await this.$services.franquiasService.getTurmasDasGestoes();

      this.turmas = turmas;
    },

    async getNotas() {
      this.loadingNotas = true;
      try {
        const data = await this.$services.turmasService.pegarNotas({
          turmas: this.turmas,
        });
        const values = data.data;
        const dados = [];

        Object.keys(values).forEach((key) => {
          dados.push({
            label: values[key].label,
            backgroundColor: values[key].backgroundColor,
            data: values[key].data.map((n) => parseInt(n, 10)).filter((n) => n),
          });
        });

        this.datasetsNotas = dados;
        this.labelsNotas = values.notasAzuis.texts;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.loadingNotas = false;
      }
    },

    async getMedias() {
      this.loadingMedias = true;
      try {
        const data = await this.$services.turmasService.pegarMedias({
          turmas: this.turmas,
        });
        const values = data.data;
        const dados = [];

        Object.keys(values).forEach((key) => {
          dados.push({
            label: values[key].label,
            backgroundColor: values[key].backgroundColor,
            data: values[key].data.map((n) => parseInt(n, 10)).filter((n) => n),
          });
        });

        this.labelsMedias = values.notas.texts;
        this.datasetsMedias = dados;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.loadingMedias = false;
      }
    },

    async getAlunos() {
      try {
        const data = await this.$services.turmasService.pegarMelhoresAlunos({
          turmas: this.turmas,
        });
        this.alunos = data.data;
        this.melhoresAlunos = data.data
          .map((value, index) => (index < 3 ? value : null))
          .filter((a) => a);

        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      }
    },

    async getAcompanhamento() {
      this.loadingAcompanhamento = true;
      try {
        const data = await this.$services.turmasService.pegarAcompanhamentos({
          turmas: this.turmas,
        });
        const values = data.data;
        const dados = [];

        Object.keys(values).forEach((key) => {
          dados.push({
            label: values[key].label,
            backgroundColor: values[key].backgroundColor,
            data: values[key].data.map((n) => parseInt(n, 10)),
          });
        });

        this.datasetsAcompanhamentos = dados;
        this.labelsAcompanhamentos = values.faltas.mesesAll.map((m) => m?.descricao);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.loadingAcompanhamento = false;
      }
    },

    async verAviso(aviso_id, aviso) {
      this.dialog_aviso = !this.dialog_aviso;
      this.$forceUpdate();
      this.url_image_aviso = await this.$services.imageService.downloadImage(
        `notifiq/avisos/download-image/${aviso_id}`
      );
      this.aviso = aviso;
    },

    async avisosProfessor() {
      try {
        const response = await this.$services.avisosService.avisosProfessor();
        this.avisos = response.avisos;
      } catch (error) {
        this.$handleError(error);
      }
    },
  },
};
</script>

<style scoped>
.aviso-contexto {
  max-width: 100%;
  word-break: break-word;
  white-space: pre-line;
  display: block;
}
</style>
